import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
// common components
import CustomAvatar from './../../../common/Avatar/Avatar';
import CustomButton from './../../../common/Forms/CustomButton/CustomButton';
import Loader from './../../../common/Loader/Loader';
// scss
import './ParticipantList.scss';

const ParticipantList = ({ batchPartList, deleteBatchPart, manageUser}) => {

	if(batchPartList && batchPartList.length > 0) {
		return (
			<div className="ParticipantList">
				{batchPartList.map(item => (
					<div className="row card-view align" key={item.id}>
						<div className="col col-lg card-heading first align">
							<CustomAvatar name={item.user_name} />
							<div className="heading">
								<div className="title">{item.user_name}</div>
							</div>
						</div>
						<div className="col-12 col-lg details second">
							<div className="row card-detail">
								<div className="col">
									<div className="title">created date</div>
									<div className="value">{moment(item.created_date).format('DD MMM YYYY')}</div>
								</div>
							</div>
						</div>
						<div className="col cardview-actions third">
							{/*<div className="line" />
							<CustomButton
								iconOnly
								iconName='edit'
								onClick={() => manageParticipant(true, 'edit')}
							/>*/}
							{/* <CustomButton
								iconOnly
								iconName='delete'
								onClick={() => deleteBatchPart(item.id)}
							/> */}
							<CustomButton
								name='delete'
								iconOnly
								iconName='delete'
								onClick={() => manageUser(true, 'delete', item.id)}
							/>
							{/*<CustomButton
								iconOnly
								iconName='arrow'
								onClick={() => toggleDetails()}
							/>*/}
						</div>
						{/*<div class="table-responsive">
							<table className="table table-bordered table-striped">
								<thead>
									<tr>
										<th scope="col">Module</th>
										<th scope="col">test 1</th>
										<th scope="col">test 2</th>
										<th scope="col">test 3</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<th scope="row">Module name</th>
										<td>60%</td>
										<td>40.8%</td>
										<td>--</td>
									</tr>
									<tr>
										<th scope="row">Module name</th>
										<td>60%</td>
										<td>40.8%</td>
										<td>20.6%</td>
									</tr>
									<tr>
										<th scope="row">Module name</th>
										<td>60%</td>
										<td>--</td>
										<td>--</td>
									</tr>
								</tbody>
							</table>
						</div>*/}
					</div>
				))}
			</div>
		);
	}
	return (<Loader />);
}

ParticipantList.propTypes = {
	batchPartList: PropTypes.instanceOf(Array),
	deleteBatchPart: PropTypes.func
};

ParticipantList.defaultProps = {
	batchPartList: [],
	deleteBatchPart: () => {}
};

export default ParticipantList;


// WEBPACK FOOTER //
// ./components/BatchParticipant/ParticipantList/ParticipantList.js